import UI from './UI'
import { connect } from 'react-redux'
import { fetchLearningPathAction, resetLearningPathAction } from './store'

const mapStateToProps = ({ learningPath }) => ({
  loading: learningPath.isLearningPathLoading
})

const mapDispatchToProps = dispatch => ({
  fetchLearningPath: (slug) => dispatch(fetchLearningPathAction(slug)),
  resetLearningPath: () => dispatch(resetLearningPathAction())
})

export default connect(mapStateToProps, mapDispatchToProps)(UI)
